import { render, staticRenderFns } from "./ModalCreateNewTeam.vue?vue&type=template&id=bb30dcc6&scoped=true"
import script from "./ModalCreateNewTeam.vue?vue&type=script&lang=js"
export * from "./ModalCreateNewTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb30dcc6",
  null
  
)

export default component.exports